import { useSelector } from 'react-redux';

import { GlobalState } from '~reducers';

export function useCurrentBusiness() {
	const business = useSelector((state: GlobalState) => state.session.business);

	return business;
}
